import Container from '@/shared/Container';
import Div from '@/shared/Div';
import Divider from '@/shared/Divider';
import Image from '@/shared/Image';
import Paragraph from '@/shared/Paragraph';
import Map from '../Map';
import LeftArrowIcon from '../Icons/LeftArrow';
import Link from '@/shared/Link';

const Vision = (props: any) => {
  const { title, image, subTitle, linksTitle, list } = props;

  const render = (item: any, index: number) => {
    const { label, href, target } = item;
    return (
      <Link
        key={item.id}
        href={href}
        target={target}
        className="group flex gap-s3 hover:text-blue-500  hover:underline text-cti-primary text-body-lg"
      >
        <LeftArrowIcon
          className="rotate-180 text-cti-primary group-hover:rotate-[135deg] group-hover:text-blue-500  transition-all "
          fill="currentColor"
        />
        {label}
      </Link>
    );
  };

  const [part1, part2] = subTitle.split(',');
  return (
    <Div className="bg-white py-7 md:py-20">
      <Container>
        <Div className="flex flex-col-reverse md:flex-row gap-16">
          <Div className="w-full md:w-1/3">
            <Image cmsImage={image} className="rounded-lg w-full" alt="vision" />
          </Div>
          <Div className="w-full md:w-2/3">
            <Paragraph className="text-h-4 text-cti-primary my-s5">{title}</Paragraph>
            <Paragraph className="hidden md:block text-cm-brand text-hd-1">
              {part1}, <br />
              {part2}
            </Paragraph>
            <Paragraph className="block md:hidden text-cm-brand text-h-1">{subTitle}</Paragraph>
            <Divider className="my-s5 md:my-s8 border-gray-500" />
            <Paragraph className="text-black text-hd-3 mb-s5">{linksTitle}</Paragraph>
            <Map list={list} render={render} className="grid md:grid-cols-2 gap-s5" />
          </Div>
        </Div>
      </Container>
    </Div>
  );
};

export default Vision;
